import { useState, useEffect, useRef } from 'react'
import { Footer, Nav } from './App'
// ─── TEAM DATA ────────────────────────────────────────────────────────────────
// Add real photos to /public/team/ and fill in the details below

interface TeamMember {
  id: number
  name: string
  role: string
  // bio: string
  image: string
  twitter?: string
  linkedin?: string
}

const TEAM: TeamMember[] = [
  {
    id: 1,
    name: 'Rivu Chakraborty',
    role: 'Founder & CTO',
    // bio: "Google Developer Expert in Kotlin. 13+ years in mobile engineering, systems used by 200M+ users. 18-year guitarist and student of legendary Amyt Dutta.",
    image: 'images/rivu.jpeg',
    twitter: 'rivuchakraborty',
    linkedin: 'rivuchk',
  },
  {
    id: 2,
    name: 'Arpan Sinha',
    role: 'Founder\'s Office',
    // bio: "Add this team member's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/Mr. Sinha.png',
    twitter: 'mr_sinhaaaa',
    linkedin: 'arpansinhaaaa',
  },
  {
    id: 3,
    name: 'Srijan Mukherjee',
    role: 'ML Intern and Lead Guitarist',
    // bio: "Add this team member's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/srijan.png',
    twitter: 'technosrijan',
    linkedin: 'technosrijan',
  },
  {
    id: 4,
    name: 'Srishti Lakhera',
    role: 'Design Lead',
    // bio: "Add this team member's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/srishti.png',
    twitter: '',
    linkedin: 'srishti-lakhera',
  },
  {
    id: 5,
    name: 'Ishika Sen',
    role: 'UX/UI Design Intern',
    // bio: "Add this team member's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/ishika.png',
    twitter: '',
    linkedin: 'ishika-sen-755b69221',
  },
  {
    id: 6,
    name: 'Mussarrat Kittur',
    role: 'Content Intern',
    // bio: "Add this team member's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/mussarat.png',
    twitter: 'mussarratkittur',
    linkedin: 'mussarrat-kittur-8b6aa3295',
  },
  {
    id: 7,
    name: 'Tuhin Bhowmick',
    role: 'Aossociate KMP Developer',
    // bio: "Add this team member's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/tuhin.png',
    twitter: 'tuuhin_',
    linkedin: 'tuuhin',
  },
  {
    id: 8,
    name: 'Ritabrata Mondal ',
    role: 'Video Editor',
    // bio: "Add this team member's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/rito.png',
    twitter: '',
    linkedin: 'ritabrata-mondal-94621a311',
  },
]

const ADVISORS: TeamMember[] = [
  {
    id: 101,
    name: 'Narendra Nath Chatterjee',
    role: 'Advisor',
    // bio: "Add this advisor's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/narendra.png',
    twitter: 'Narendr83598942',
    linkedin: 'narendra-nath-chatterjee-8a7651133/',
  },
  {
    id: 102,
    name: 'Imran Roshan',
    role: 'Advisor',
    // bio: "Add this advisor's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/imran.png',
    twitter: 'imranfosec',
    linkedin: 'imranfosec',
  },
  {
    id: 103,
    name: 'Nikhilesh Tayal',
    role: 'Advisor',
    // bio: "Add this advisor's bio here. Describe their background, expertise, and what they bring to FretPractice.",
    image: '/images/Nikhilesh.png',
    twitter: 'losesaga',
    linkedin: 'nikhileshtayal',
  },
]

// ─── HOOKS ────────────────────────────────────────────────────────────────────

function useWindowWidth(): number {
  const [w, setW] = useState(0)
  useEffect(() => {
    const fn = () => setW(window.innerWidth)
    fn()
    window.addEventListener('resize', fn)
    return () => window.removeEventListener('resize', fn)
  }, [])
  return w
}



function useInView(threshold = 0.1) {
  const ref = useRef<HTMLDivElement>(null)
  const [inView, setInView] = useState(false)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const io = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); io.disconnect() } },
      { threshold, rootMargin: '0px 0px -60px 0px' }
    )
    io.observe(el)
    return () => io.disconnect()
  }, [threshold])
  return { ref, inView }
}


// ─── GLOBAL STYLES ────────────────────────────────────────────────────────────

function GlobalStyles() {
  useEffect(() => {
    const s = document.createElement('style')
    s.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;1,9..40,300&display=swap');
      *,*::before,*::after { box-sizing: border-box; }
      html { scroll-behavior: smooth; }
      body { margin: 0; padding: 0; background: #000; color: rgba(255,255,255,0.88); font-family: 'DM Sans', sans-serif; font-weight: 300; overflow-x: hidden; -webkit-font-smoothing: antialiased; }
      body::after { content: ''; position: fixed; inset: 0; pointer-events: none; z-index: 9998; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='g'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23g)' opacity='0.05'/%3E%3C/svg%3E"); opacity: 0.28; }
      ::-webkit-scrollbar { width: 5px; }
      ::-webkit-scrollbar-track { background: #000; }
      ::-webkit-scrollbar-thumb { background: rgba(37,89,244,0.35); border-radius: 10px; }
      ::-webkit-scrollbar-thumb:hover { background: rgba(37,89,244,0.6); }
      @keyframes riseIn { from { opacity: 0; transform: translateY(22px); } to { opacity: 1; transform: translateY(0); } }
      @keyframes breathePulse { 0%,100% { box-shadow: 0 0 0 4px rgba(37,89,244,0.2); } 50% { box-shadow: 0 0 0 8px rgba(37,89,244,0.06); } }
      @keyframes floatA { 0%,100% { transform: translate(0,0) scale(1); } 33% { transform: translate(35px,-25px) scale(1.04); } 66% { transform: translate(-20px,30px) scale(0.97); } }
    `
    document.head.appendChild(s)
    return () => { document.head.removeChild(s) }
  }, [])
  return null
}

// ─── REVEAL ───────────────────────────────────────────────────────────────────

function Reveal({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) {
  const { ref, inView } = useInView()
  return (
    <div ref={ref} style={{ opacity: inView ? 1 : 0, transform: inView ? 'translateY(0)' : 'translateY(40px)', transition: `opacity .85s cubic-bezier(.16,1,.3,1) ${delay}s, transform .85s cubic-bezier(.16,1,.3,1) ${delay}s` }}>
      {children}
    </div>
  )
}



// ─── HERO ─────────────────────────────────────────────────────────────────────

function TeamHero() {
  const w = useWindowWidth()
  const isMobile = w < 768
  return (
    <section style={{ minHeight: isMobile ? '52vh' : '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: isMobile ? '100px 20px 56px' : '120px 52px 80px', position: 'relative', overflow: 'hidden', textAlign: 'center' }}>

      {/* Ambient glows */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', width: 700, height: 700, top: -250, left: '50%', transform: 'translateX(-50%)', borderRadius: '50%', background: 'radial-gradient(circle, rgba(37,89,244,0.18) 0%, transparent 65%)', filter: 'blur(80px)', animation: 'floatA 22s ease-in-out infinite' }} />
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.06) 1px, transparent 1px)', backgroundSize: '44px 44px', maskImage: 'radial-gradient(ellipse 70% 60% at 50% 40%, black 20%, transparent 70%)', WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at 50% 40%, black 20%, transparent 70%)' }} />
      </div>

      {/* Eyebrow */}
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12, fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 500, letterSpacing: '0.15em', textTransform: 'uppercase', color: '#2559F4', marginBottom: 24, animation: 'riseIn .9s cubic-bezier(.16,1,.3,1) .1s both' }}>
        <span style={{ display: 'block', width: 24, height: 1, background: '#2559F4' }} />
        The People
        <span style={{ display: 'block', width: 24, height: 1, background: '#2559F4' }} />
      </div>

      {/* Headline */}
      <h1 style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: isMobile ? 'clamp(44px,10vw,72px)' : 'clamp(60px,8vw,108px)', fontWeight: 400, lineHeight: 0.92, letterSpacing: '0.04em', color: '#fff', maxWidth: 820, margin: '0 auto 28px', animation: 'riseIn .9s cubic-bezier(.16,1,.3,1) .2s both' }}>
        Built by people<br />
        <span style={{ background: 'linear-gradient(130deg, #7eb8ff 0%, #2559F4 45%, #1438b0 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>who play.</span>
      </h1>

      {/* Subtext */}
      <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: isMobile ? 15 : 18, color: 'rgba(255,255,255,0.44)', fontWeight: 300, lineHeight: 1.78, maxWidth: 520, margin: '0 auto', animation: 'riseIn .9s cubic-bezier(.16,1,.3,1) .32s both' }}>
        Every decision is shaped by engineers who practice, musicians who think in systems, and builders who obsess over craft.
      </p>
    </section>
  )
}

// ─── SOCIAL LINK ──────────────────────────────────────────────────────────────

function SocialLink({ href, label, icon }: { href: string; label: string; icon: React.ReactNode }) {
  const [hov, setHov] = useState(false)
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-hover
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{ width: 34, height: 34, borderRadius: 9, display: 'flex', alignItems: 'center', justifyContent: 'center', background: hov ? 'rgba(37,89,244,0.12)' : 'rgba(255,255,255,0.04)', border: `1px solid ${hov ? 'rgba(37,89,244,0.35)' : 'rgba(255,255,255,0.1)'}`, color: hov ? '#fff' : 'rgba(255,255,255,0.4)', transform: hov ? 'translateY(-2px)' : 'none', transition: 'all .3s cubic-bezier(.16,1,.3,1)', cursor: 'pointer', textDecoration: 'none' }}
    >
      {icon}
    </a>
  )
}

// ─── MEMBER CARD ──────────────────────────────────────────────────────────────

function MemberCard({ member, delay }: { member: TeamMember; delay: number }) {
  const [hov, setHov] = useState(false)
  const [imgErr, setImgErr] = useState(false)
  const w = useWindowWidth()
  const isMobile = w < 768

  const initials = member.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()

  return (
    <Reveal delay={delay}>
      <div
        data-hover
        onMouseEnter={() => setHov(true)}
        onMouseLeave={() => setHov(false)}
        style={{ background: hov ? '#0d1223' : '#0a0d17', border: `1px solid ${hov ? 'rgba(37,89,244,0.35)' : 'rgba(255,255,255,0.08)'}`, borderRadius: 22, overflow: 'hidden', transition: 'background .4s, border-color .35s, transform .35s cubic-bezier(.16,1,.3,1), box-shadow .35s', transform: hov ? 'translateY(-6px)' : 'none', boxShadow: hov ? '0 24px 72px rgba(0,0,0,0.55), 0 0 40px rgba(37,89,244,0.08)' : 'none', cursor: 'pointer', position: 'relative' }}
      >
        {/* Top accent on hover */}
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: 'linear-gradient(90deg, transparent, #2559F4, transparent)', transform: hov ? 'scaleX(1)' : 'scaleX(0)', transition: 'transform .45s cubic-bezier(.16,1,.3,1)', transformOrigin: 'center' }} />

        {/* Photo */}
        <div style={{ position: 'relative', width: '100%', paddingBottom: '100%', overflow: 'hidden', background: 'linear-gradient(145deg, #111827, #0a0d17)' }}>
          {!imgErr ? (
            <img
              src={member.image}
              alt={member.name}
              draggable="false"
              onError={() => setImgErr(true)}
              style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center top', transition: 'transform .6s cubic-bezier(.16,1,.3,1)', transform: hov ? 'scale(1.05)' : 'scale(1)', userSelect: 'none' }}
            />
          ) : (
            <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(145deg, #111827, #0d1223)' }}>
              <div style={{ width: 80, height: 80, borderRadius: '50%', background: 'rgba(37,89,244,0.12)', border: '1px solid rgba(37,89,244,0.28)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Bebas Neue',sans-serif", fontSize: 28, letterSpacing: '0.04em', color: '#2559F4' }}>
                {initials}
              </div>
            </div>
          )}
          {/* Fade overlay */}
          <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '45%', background: 'linear-gradient(to top, rgba(10,13,23,0.96), transparent)', pointerEvents: 'none' }} />
        </div>

        {/* Card content */}
        <div style={{ padding: isMobile ? '22px 22px 24px' : '26px 28px 28px' }}>

          {/* Role badge */}
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, background: 'rgba(37,89,244,0.1)', border: '1px solid rgba(37,89,244,0.2)', borderRadius: 100, padding: '4px 12px', marginBottom: 14 }}>
            <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#2559F4', display: 'block' }} />
            <span style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 10.5, fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase' as const, color: '#2559F4' }}>{member.role}</span>
          </div>

          {/* Name */}
          <div style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: isMobile ? 22 : 26, letterSpacing: '0.04em', color: '#fff', lineHeight: 1.05, marginBottom: 12 }}>
            {member.name}
          </div>

          {/* Bio */}
          {/* <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: isMobile ? 13 : 13.5, lineHeight: 1.78, color: 'rgba(255,255,255,0.44)', fontWeight: 300, margin: '0 0 20px' }}>
            {member.bio}
          </p> */}


          {/* Divider */}
          <div style={{ height: 1, background: 'rgba(255,255,255,0.07)', marginBottom: 18 }} />

          {/* Social row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {member.twitter && (
              <SocialLink
                href={`https://twitter.com/${member.twitter}`}
                label="X / Twitter"
                icon={
                  <svg viewBox="0 0 24 24" style={{ width: 14, height: 14, fill: 'currentColor' }}>
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                }
              />
            )}
            {member.linkedin && (
              <SocialLink
                href={`https://linkedin.com/in/${member.linkedin}`}
                label="LinkedIn"
                icon={
                  <svg viewBox="0 0 24 24" style={{ width: 14, height: 14, fill: 'currentColor' }}>
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                }
              />
            )}
            {member.twitter && (
              <span style={{ marginLeft: 'auto', fontFamily: "'DM Sans',sans-serif", fontSize: 11, color: 'rgba(255,255,255,0.2)', letterSpacing: '0.02em' }}>
                @{member.twitter}
              </span>
            )}
          </div>
        </div>
      </div>
    </Reveal>
  )
}

// ─── TEAM GRID ────────────────────────────────────────────────────────────────

function TeamMembersList({ title, members }: { title: string; members: TeamMember[] }) {
  const w = useWindowWidth()
  const isMobile = w < 640
  const isTablet = w >= 640 && w < 1024
  const cols = isMobile ? 1 : isTablet ? 2 : 3

  if (!members.length) return null

  const completeRowsCount = Math.floor(members.length / cols) * cols
  const gridMembers = members.slice(0, completeRowsCount)
  const remainder = members.slice(completeRowsCount)

  return (
    <div style={{ marginBottom: 100 }}>
      {title && (
        <h2 style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: isMobile ? 36 : 48, color: '#fff', marginBottom: 40, letterSpacing: '0.04em', textAlign: 'center' }}>
          {title}
        </h2>
      )}

      {gridMembers.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: `repeat(${cols}, 1fr)`, gap: isMobile ? 18 : 24, marginBottom: remainder.length ? (isMobile ? 18 : 24) : 0 }}>
          {gridMembers.map((m, i) => (
            <MemberCard key={m.id} member={m} delay={i * 0.07} />
          ))}
        </div>
      )}

      {remainder.length > 0 && (
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: isMobile ? 18 : 24 }}>
          {remainder.map((m, i) => (
            <div key={m.id} style={{ width: isMobile ? '100%' : isTablet ? 'calc(50% - 12px)' : 'calc(33.333% - 16px)' }}>
              <MemberCard member={m} delay={(gridMembers.length + i) * 0.07} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

function TeamGrid() {
  const w = useWindowWidth()
  const isMobile = w < 640

  return (
    <section style={{ padding: isMobile ? '20px 0 100px' : '40px 0 120px', background: '#000' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: `0 ${isMobile ? '20px' : '52px'}` }}>
        <TeamMembersList title="Team" members={TEAM} />
        <TeamMembersList title="Advisors" members={ADVISORS} />
      </div>
    </section>
  )
}

// ─── JOIN BANNER ─────────────────────────────────────────────────────────────

function JoinSection() {
  const w = useWindowWidth()
  const isMobile = w < 768
  const [hov, setHov] = useState(false)

  return (
    <section style={{ padding: isMobile ? '80px 0 100px' : '120px 0 140px', background: '#0a0d17', position: 'relative', overflow: 'hidden', textAlign: 'center' }}>
      <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(37,89,244,0.1) 0%, transparent 70%)', pointerEvents: 'none' }} />
      <div style={{ maxWidth: 600, margin: '0 auto', padding: `0 ${isMobile ? '20px' : '52px'}`, position: 'relative', zIndex: 1 }}>
        <Reveal>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12, fontFamily: "'DM Sans',sans-serif", fontSize: 11, fontWeight: 500, letterSpacing: '0.15em', textTransform: 'uppercase' as const, color: '#2559F4', marginBottom: 24 }}>
            <span style={{ display: 'block', width: 24, height: 1, background: '#2559F4' }} />
            We're building
            <span style={{ display: 'block', width: 24, height: 1, background: '#2559F4' }} />
          </div>

          <h2 style={{ fontFamily: "'Bebas Neue',sans-serif", fontSize: isMobile ? 'clamp(36px,8vw,56px)' : 'clamp(44px,5vw,72px)', fontWeight: 400, lineHeight: 0.96, letterSpacing: '0.04em', color: '#fff', marginBottom: 18 }}>
            Want to be part<br />of this?
          </h2>

          <p style={{ fontFamily: "'DM Sans',sans-serif", fontSize: isMobile ? 14 : 16, lineHeight: 1.8, color: 'rgba(255,255,255,0.44)', fontWeight: 300, marginBottom: 44 }}>
            We're always looking for musicians who build and builders who play. If that's you, reach out.
          </p>

          <a
            href="mailto:fretpractice@mobrio.studio"
            data-hover
            onMouseEnter={() => setHov(true)}
            onMouseLeave={() => setHov(false)}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: '#2559F4', color: '#fff', textDecoration: 'none', fontFamily: "'DM Sans',sans-serif", fontSize: 14, fontWeight: 500, padding: '14px 30px', borderRadius: 10, cursor: 'pointer', boxShadow: hov ? '0 0 0 1px rgba(37,89,244,0.7), 0 16px 48px rgba(37,89,244,0.48)' : 'none', transform: hov ? 'translateY(-2px)' : 'none', transition: 'box-shadow .35s cubic-bezier(.16,1,.3,1), transform .3s cubic-bezier(.16,1,.3,1)' }}
          >
            Get in touch →
          </a>
        </Reveal>
      </div>
    </section>
  )
}

// ─── PAGE ─────────────────────────────────────────────────────────────────────

export default function Team() {
  useEffect(() => {
    const prev = document.title
    document.title = 'Meet the Team — FretPractice'
    const meta = document.querySelector('meta[name="description"]')
    const prevDesc = meta?.getAttribute('content') || ''
    meta?.setAttribute('content', 'Meet the team behind FretPractice — engineers who play, musicians who build, and advisors obsessed with helping guitarists improve.')
    return () => { document.title = prev; meta?.setAttribute('content', prevDesc) }
  }, [])

  // Disable right-click to deter casual image saving
  useEffect(() => {
    const handler = (e: MouseEvent) => e.preventDefault()
    document.addEventListener('contextmenu', handler)
    return () => document.removeEventListener('contextmenu', handler)
  }, [])
  return (
    <>
      <GlobalStyles />
      <Nav />
      <TeamHero />
      <TeamGrid />
      <JoinSection />
      <Footer />
    </>
  )
}